import type { ApiResponse, PageResult } from '@wanjianshi/shared-contracts';
import { adminApi } from '@/services/api/client';

interface AdminRoleRow {
  id?: string | number;
  name?: string;
  code?: string;
  status?: string | number;
}

export interface AdminRoleOption {
  label: string;
  value: number;
}

export async function loadAdminRoleOptions(
  signal?: AbortSignal,
): Promise<AdminRoleOption[]> {
  const response = await adminApi.get<ApiResponse<PageResult<AdminRoleRow>>>(
    '/admin/roles',
    { params: { page: 1, page_size: 200 }, signal },
  );
  return (response.data.items ?? [])
    .filter(role => Number(role.status ?? 0) === 0 && String(role.code ?? '').startsWith('wjs_admin_'))
    .map(role => ({
      label: `${String(role.name || '未命名角色')}（${String(role.code)}）`,
      value: Number(role.id),
    }))
    .filter(role => Number.isSafeInteger(role.value) && role.value > 0);
}
